import { create } from 'zustand';

interface UIStore {
  isChatBotOpen: boolean;
  chatBotInitialMessage: string | null;
  openChatBot: (initialMessage?: string) => void;
  closeChatBot: () => void;
}

export const useUIStore = create<UIStore>((set) => ({
  isChatBotOpen: false,
  chatBotInitialMessage: null,
  openChatBot: (initialMessage?: string) => set({ isChatBotOpen: true, chatBotInitialMessage: initialMessage || null }),
  closeChatBot: () => set({ isChatBotOpen: false, chatBotInitialMessage: null }),
}));
